mvCreateJsonp([2],{

/***/ "hiL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ../node_modules/jump.js/dist/jump.module.js
// Robert Penner's easeInOutQuad

// find the rest of his easing functions here: http://robertpenner.com/easing/
// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js

var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var jumper = function jumper() {
  // private variable cache
  // no variables are created during a jump, preventing memory leaks

  var element = void 0; // element to scroll to                   (node)

  var start = void 0; // where scroll starts                    (px)
  var stop = void 0; // where scroll stops                     (px)

  var offset = void 0; // adjustment from the stop position      (px)
  var easing = void 0; // easing function                        (function)
  var a11y = void 0; // accessibility support flag             (boolean)

  var distance = void 0; // distance of scroll                     (px)
  var duration = void 0; // scroll duration                        (ms)

  var timeStart = void 0; // time scroll started                    (ms)
  var timeElapsed = void 0; // time spent scrolling thus far          (ms)

  var next = void 0; // next scroll position                   (px)

  var callback = void 0; // to call when done scrolling            (function)

  // scroll position helper

  function location() {
    return window.scrollY || window.pageYOffset;
  }

  // element offset helper

  function top(element) {
    return element.getBoundingClientRect().top + start;
  }

  // rAF loop helper

  function loop(timeCurrent) {
    // store time scroll started, if not started already
    if (!timeStart) {
      timeStart = timeCurrent;
    }

    // determine time spent scrolling so far
    timeElapsed = timeCurrent - timeStart;

    // calculate next scroll position
    next = easing(timeElapsed, start, distance, duration);

    // scroll to it
    window.scrollTo(0, next);

    // check progress
    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
    : done(); // scrolling is done
  }

  // scroll finished helper

  function done() {
    // account for rAF time rounding inaccuracies
    window.scrollTo(0, start + distance);

    // if scrolling to an element, and accessibility is enabled
    if (element && a11y) {
      // add tabindex indicating programmatic focus
      element.setAttribute('tabindex', '-1');

      // focus the element
      element.focus();
    }

    // if it exists, fire the callback
    if (typeof callback === 'function') {
      callback();
    }

    // reset time for next jump
    timeStart = false;
  }

  // API

  function jump(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // resolve options, or use defaults
    duration = options.duration || 1000;
    offset = options.offset || 0;
    callback = options.callback; // "undefined" is a suitable default, and won't be called
    easing = options.easing || easeInOutQuad;
    a11y = options.a11y || false;

    // cache starting position
    start = location();

    // resolve target
    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
      // scroll from current position
      case 'number':
        element = undefined; // no element to scroll to
        a11y = false; // make sure accessibility is off
        stop = start + target;
        break;

      // scroll to element (node)
      // bounding rect is relative to the viewport
      case 'object':
        element = target;
        stop = top(element);
        break;

      // scroll to element (selector)
      // bounding rect is relative to the viewport
      case 'string':
        element = document.querySelector(target);
        stop = top(element);
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    // resolve duration
    switch (_typeof(options.duration)) {
      // number in ms
      case 'number':
        duration = options.duration;
        break;

      // function passed the distance of the scroll
      case 'function':
        duration = options.duration(distance);
        break;
    }

    // start the loop
    window.requestAnimationFrame(loop);
  }

  // expose only the jump method
  return jump;
};

// export singleton

var singleton = jumper();

/* harmony default export */ var jump_module = (singleton);
// CONCATENATED MODULE: ./ScrollButton/index.js


var EXPECTED_AD_PLACEMENT_TIME = 3000; // Ballpark estimate of how long ads should take to place
var AFTER_AD_PLACEMENT_REMAINING_BUFFER = 500; // After ads are placed, how long to complete scroll

var ScrollButton_easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

// window.$mediavine.web.model.videoSettings.mobile_popout_placement

var preCreateTarget = document.querySelector('.mv-pre-create-target');
// Ensure no initial top padding
preCreateTarget.style.paddingTop = '0';

var ScrollButton_handleClick = function handleClick(e) {
  return new Promise(function ($return, $error) {
    var $Try_1_Finally = function ($Try_1_Exit) {
      return function ($Try_1_Value) {
        try {
          jump_module(anchor, {
            duration: EXPECTED_AD_PLACEMENT_TIME,
            callback: function callback() {
              jump_module(anchor, {
                durration: AFTER_AD_PLACEMENT_REMAINING_BUFFER,
                easing: ScrollButton_easeInOutQuad,
                offset: offset,
                callback: function callback() {
                  if (!window.mvCreate.jtrClicked) {
                    if (window.$mediavine.web && window.$mediavine.web.setContentWaypointDisable) {
                      window.$mediavine.web.setContentWaypointDisable(false);
                    }
                  }
                }
              });
            },
            offset: offset,
            easing: ScrollButton_easeInOutQuad
          });
          window.mvCreate.init(card, 410);
          window.mvCreate.jtrClicked = true;
          return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this);
    }.bind(this);

    var hash, anchor, card, wrapper, offset, continueBtn;

    if (!window.$mediavine) {
      return $return();
    }

    e.preventDefault();

    // Add top padding for ad placement once button has been clicked
    preCreateTarget.style.paddingTop = '45px';

    hash = e.target.hash;

    anchor = document.querySelector(hash);
    card = document.querySelector(hash.replace('-jtr', ''));
    wrapper = document.querySelector(hash);
    offset = 0;
    // Set anchor
    if (!window.mvCreate.jtrClicked) {
      anchor.style.height = '340px';
      anchor.innerHTML = anchor.innerHTML + '<div class="mv_slot_target" data-slot="recipe"></div>';
      continueBtn = wrapper.querySelector('.mv-create-jtr-continue');

      if (continueBtn) {
        continueBtn.style.display = 'block';
      }

      if (window.$mediavine.web.model && window.$mediavine.web.model.sidebar_btf_sticky_offset) {
        offset = -Math.abs(parseInt(window.$mediavine.web.model.sidebar_btf_sticky_offset));
      }

      if (window.innerWidth < 600 && window.$mediavine.web.model && window.$mediavine.web.model.videoSettings && window.$mediavine.web.model.videoSettings.mobile_popout_placement === 'top_left') {
        continueBtn.style.textAlign = 'right';
      }

      if (window.$mediavine.web && window.$mediavine.web.setContentWaypointDisable) {
        window.$mediavine.web.setContentWaypointDisable(true);
      }
    }

    // Trigger a scroll to the card that should take roughly as long
    // as the ads take to place. Start scroll before initialiazing ads.
    // This returns a promise so we can chain additional actions after
    // the preliminary scroll resolves.

    var $Try_1_Post = function () {
      try {
        return $return();
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };var $Try_1_Catch = function (err) {
      try {
        // Don't do anything with errors
        console.log(err);
        return $Try_1_Finally($Try_1_Post)();
      } catch ($boundEx) {
        return $Try_1_Finally($error)($boundEx);
      }
    };try {
      // Attempt to render ads. Both these functions return
      // promises, so we can block until they're complete.
      if (!window.mvCreate.jtrClicked) {
        if (window.$mediavine.web.load) {
          return Promise.resolve(window.$mediavine.web.load()).then(function ($await_5) {
            try {
              return $If_3.call(this);
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }.bind(this), $Try_1_Catch);
        }

        function $If_3() {
          if (window.$mediavine.web.renderLazyAds) {
            return Promise.resolve(window.$mediavine.web.renderLazyAds(wrapper)).then(function ($await_6) {
              try {
                return $If_4.call(this);
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }.bind(this), $Try_1_Catch);
          }

          function $If_4() {
            return $If_2.call(this);
          }

          return $If_4.call(this);
        }

        return $If_3.call(this);
      }

      function $If_2() {
        return $Try_1_Finally($Try_1_Post)();
      }

      return $If_2.call(this);
    } catch (err) {
      $Try_1_Catch(err)
    }
  });
};

var hasJtr = document.querySelector('.mv-create-jtr');
if (hasJtr) {
  hasJtr.addEventListener('click', ScrollButton_handleClick, false);
}

/***/ })

});


// WEBPACK FOOTER //
// mv-scroll-button.chunk.1ce52.js